export default "__VITE_ASSET__a9670225__"